export function facilityLabelData(f, admin) {
  if (admin) {
    return {
      label: (
        <>
          <code>{f.shortId}</code> – {f.area.location} – {f.area.name} — 
          <code>{f.code}</code>
        </>
      ),
      strLabel: `${f.shortId} - ${f.area.location} - ${f.area.name}`
    }
  }
  const name = (
    <>
      <code>{f.code}</code> – {f.area.location} – {f.area.name} (
      <code>{f.shortId}</code>)
    </>
  )
  const strLabel = `${f.code} - ${f.shortId} - ${f.area.location} - ${f.area.name}`
  return { label: name, sort: f.code, strLabel }
}
